/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Reversing happens entirely in your browser; nothing is sent to a server.`)
};

const es_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La inversión ocurre completamente en tu navegador; nada se envía a un servidor.`)
};

const de_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Umkehrung erfolgt vollständig in deinem Browser; es wird nichts an einen Server gesendet.`)
};

const nl_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Omkeren gebeurt volledig in je browser; niets wordt naar een server verzonden.`)
};

const fr_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. L'inversion se fait entièrement dans votre navigateur; rien n'est envoyé à un serveur.`)
};

const it_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. L'inversione avviene interamente nel tuo browser; niente viene inviato a un server.`)
};

const pt_br2_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A inversão ocorre inteiramente no seu navegador; nada é enviado para um servidor.`)
};

const pt_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A inversão ocorre totalmente no seu navegador; nada é enviado para um servidor.`)
};

const ja_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。反転はブラウザ内で完全に実行されます。サーバーには何も送信されません。`)
};

const zh_rv_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。反转操作完全在你的浏览器中进行，不会有任何内容被发送到服务器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq3_a", locale)
	if (locale === "en") return en_rv_faq3_a(inputs)
	if (locale === "es") return es_rv_faq3_a(inputs)
	if (locale === "de") return de_rv_faq3_a(inputs)
	if (locale === "nl") return nl_rv_faq3_a(inputs)
	if (locale === "fr") return fr_rv_faq3_a(inputs)
	if (locale === "it") return it_rv_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq3_a(inputs)
	if (locale === "pt") return pt_rv_faq3_a(inputs)
	if (locale === "ja") return ja_rv_faq3_a(inputs)
	return zh_rv_faq3_a(inputs)
};